import Cookies from "js.cookie"
import { decrypte, encrypte } from "./crypto";
import { env } from "./config";

const cookiesHandler = {
    config() {
        let cookie_options = {
            expires: 365,
            path: '/',
            secure: true,
            sameSite: 'Strict'
        }

        if (env('APP_PRODUCTION')) {
            cookie_options.domain = 'cervodigital.com.br';
        }

        return cookie_options;
    },

    hasCookie(cookieName = '') {
        return ![null, undefined, ''].includes(Cookies.get(cookieName)) ? true : false;
    },

    saveCookie(cookieName, value = '') {
        if (!cookieName || !this.hasAcceptedCookies()) {
            return false;
        }
        Cookies.set(cookieName, value.toString(), this.config());
    },

    getCookie(cookieName = '') {
        return Cookies.get(cookieName);
    },

    saveCookieAcceptance(value = true) {
        Cookies.set('accepted_cookies', value, this.config());
    },

    removeCookieAcceptance() {
        Cookies.remove('accepted_cookies');
    },

    hasAcceptedCookies() {
        return this.getCookie('accepted_cookies') ?? false;
    },

    setEncryptedCookie(cookieName, value = '') {
        if (this.hasAcceptedCookies()) {
            Cookies.set(cookieName, encrypte(value), this.config());
        }
    },

    getEncryptedCookie(cookieName) {
        return decrypte(Cookies.get(cookieName));
    },
}

export default cookiesHandler;